export const RELEASE_LINE = {
  angular: '10.2.x',
  packageVersion: '10.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 10 + Angular CLI',
  docsPath: '/angular-10/'
};
